import React from "react";
import { Routes, Route, Navigate, BrowserRouter } from "react-router-dom";
import AppRoutes from "./AppRoutes";
import HomeScreen from "./components/layout";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const App = () => {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Navigate to="/clubedemo/login" />} />
        <Route path="/:slug/*" element={<AppRoutes />} />
      </Routes>
      <ToastContainer />
    </BrowserRouter>
  );
};

export default App;
